import AppErrorDefault from './Default.vue';
import AppErrorNotFound from './NotFound.vue';

export default { AppErrorDefault, AppErrorNotFound };
